import styled, { css } from 'styled-components'

import { theme } from 'utils/style'
import DayPicker from 'components/DayPicker/DayPickerContainer'

const stylesWithoutBorder = css`
  display: block;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  padding: 0 0.44em;
  height: 2.22em;
  color: ${theme('colors.grayscale.darkest')};
  background: none;
  border: none;

  &[type='checkbox'],
  &[type='radio'] {
    display: inline-block;
    border: 0;
    border-radius: 0;
    width: auto;
    height: auto;
    margin: 0 0.2rem 0 0;
  }
`

const styles = css`
  ${stylesWithoutBorder}

  border-bottom: 0.1rem solid ${theme('colors.grayscale.light')};
  transition: all 0.3s ease;

  &:focus {
    border-color: ${theme('colors.primary')};
    outline: none;
  }
`
export const StyledTextarea = styled.textarea`
  ${styles}
  padding: ${theme('spaces.m')};
  border: 1px solid ${theme('colors.grayscale.light')};
`

export const StyledSelect = styled.select`
  ${styles}
  appearance: none;
  border-radius: 0;
`

export const StyledInput = styled.input`
  ${styles}
`
export const StyledCheckbox = styled.input`
  ${stylesWithoutBorder}
`
export const StyledDayPicker = styled(DayPicker)`
  display: block;
  width: 100%;

  input {
    ${styles}
  }
`
